import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const updateSubCategoryAction = createAsyncThunk(
    'update-sub-category',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.patch(`/support-server/api/update-sub-category`, { ...data })
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const updateSubCategorySlice = createSlice({
    name: 'update-sub-category',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(updateSubCategoryAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(updateSubCategoryAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(updateSubCategoryAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const updateSubCategoryReducer = updateSubCategorySlice.reducer    